import {makeExecutableSchema} from 'graphql-tools'
import resolvers from './resolvers'
/* TablePermission options = [a:All,f:Find,c:Create,u:Update,d:Delete] */
const typeDefs =`
input FieldOptions{
    required:Boolean
    uniquie:Boolean
    default:String
    lowerCase:Boolean
    upperCase:Boolean
    trim:Boolean
    enum:[String]
    many:Boolean
    manyToMany:Boolean
},
input TableOptions{
    authenticated:Boolean
    mapToUser:Boolean
    mapedPermissions:[String]
    authenticationPermissions:[String]
}
input Field{
    name:String!
    type:String!
    options:FieldOptions
    
},
type table{
    name:String
}

type Query{
    welcome:String
    tableTest:table
    tableTest2:table
    time:String
  
},
type Mutation{
    registerSchema(name:String!,fields:[Field],options:TableOptions):String,
    generateFiles(title:String!,db:String!):String
}

`
const Schema = makeExecutableSchema({typeDefs,resolvers});
export default Schema
